module.exports = __webpack_public_path__ + "static/media/day-100-measurements.9d5e2153.svg";